import { useEffect, useState } from 'react';
import { Session } from '@supabase/supabase-js';
import { supabase } from '../services/supabaseClient.ts';

export function useSession() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
      console.log('[useSession] Initial session loaded:', !!data.session);
    });

    // Subscribe to auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
      console.log('[useSession] Auth state changed:', _event, !!session);
    });

    return () => {
      subscription.unsubscribe();
      console.log('[useSession] Subscription cleaned up');
    };
  }, []);

  return { session, loading };
} 